import styles from "./Card.module.scss";

const Card = ({ title, icon, text, elements, shadow }) => {
  return (
    <div className={`${styles.card} ${shadow && styles.shadow}`}>
      <i className={`fa-solid ${icon}`}></i>
      <h2>{title}</h2>
      { text && <p>{text}</p> }
      { 
        elements &&
          elements.map((element, index) => <div key={index}>{element}</div>)
      }
    </div>
  );
};

export default Card;
